import { FleekError } from './FleekError';

type WriteFileFromStreamErrorOptions = Record<string, never>;

export class WriteFileFromStreamError extends FleekError<WriteFileFromStreamErrorOptions> {
  public name = 'WriteFileFromStreamError';

  constructor() {
    super({});
  }

  toString = () => `There was an error while writing file from stream in globSource`;
}
